
<div class="mb-4 d-flex-between">
  <div class="d-grid">
    <h3 class="mb-0">{{ "appointment.page-title" | translate }}</h3>
    <p>{{ "appointment.page-description" | translate }}</p>
  </div>
  <div class="d-flex align-items-center">
    <button
      type="button"
      class="btn ms-2"
      (click)="changeView('list')"
      [ngClass]="viewType === 'list' ? 'btn-primary' : 'light btn-dark'"
    >
      <i class="bi bi-list"></i>
    </button>

    <button
      type="button"
      class="btn ms-2"
      (click)="changeView('card')"
      [ngClass]="viewType === 'card' ? 'btn-primary' : 'light btn-dark'"
    >
      <i class="bi bi-card-text"></i>
    </button>

    <button
      type="button"
      class="btn btn-warning ms-2"
      (click)="filterCollaps = !filterCollaps"
    >
      {{ "general.filter" | translate }}
    </button>
     <a
      class="btn btn-primary ms-2"
      [routerLink]="['/case', { fullscreen: true, appointment: true }]"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ "appointment.add-button" | translate }}
    </a>
  </div>
</div>
<!-- row -->

<div class="row" *ngIf="viewType=='list'" >
  <div class="col-xl-12 active-p">
    <div class="filter cm-content-box box-primary" *ngIf="filterCollaps">
      <div class="content-title">
        <div class="cpa">
          <i class="fa-sharp fa-solid fa-filter me-2"></i
          >{{ "general.filter" | translate }}
        </div>
        <div class="tools">
          <button
          type="button"
          class="btn btn-default btn-icon-md"
          (click)="filterCollaps = false"
        >
          <i class="fa fa-close"></i>
        </button>

        </div>
      </div>

      <div class="cm-content-body form excerpt">
        <div class="card-body">
          <div class="row">

            <div class="col-xl-3 col-12 col-sm-12 ">
              <input
                type="search"
                class="form-control mb-xl-0 mb-3"
                [placeholder]="'appointment.search-text-placeholder' | translate"
                aria-controls="appointment-tbl"
                [(ngModel)]="filter.searchTerm"
              />
            </div>

            <div class="col-xl-3 col-sm-12">
              <p-calendar
                [(ngModel)]="filter.startDate"
                [placeholder]="'announcement.start-date' | translate"
                [showTime]="false"
                [showButtonBar]="true"
                appendTo="body"
                #startCalendar
                [dateFormat]="'dd.mm.yy'"
              />
            </div>
             <div class="col-xl-3 col-sm-12">
              <p-multiSelect
                [options]="caseTypes"
                [(ngModel)]="filter.caseTypes"
                [filter]="true"
                [placeholder]="'mobile-status.appointment.case-type' | translate"
                [display]="'chip'"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
              >
              </p-multiSelect>
            </div>
            <div class="col-xl-3 col-sm-12">
              <p-dropdown
                [options]="appointmentStatuses"
                [(ngModel)]="filter.appointmentStatus"
                [filter]="true"
                [placeholder]="'mobile-status.appointment-status' | translate"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
              >
              </p-dropdown>
            </div>



          </div>
          <div class="col-12 d-flex justify-content-end mt-3">
            <button
              class="btn btn-danger light"
              (click)="clearFilter()"
              type="button"
            >
              {{ "general.clear-filter" | translate }}
            </button>
            <button (click)="getList({})" class="btn btn-info ms-2" type="button">
              {{ "general.filtering" | translate }}
              <i class="fa fa-search ms-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-content" id="pills-tabContent">
      <!-- List View -->
      <div
        *ngIf="viewType == 'list'"
        class="tab-pane fade active show"
        id="pills-list"
        role="tabpanel"
      >
        <div class="card">
          <div class="card-body p-0">
            <div
              class="table-responsive active-projects appointment-tbl dt-filter"
            >
              <div class="tbl-caption">
                <h4 class="heading mb-0">
                  {{ "appointment.page-title" | translate }}
                </h4>
              </div>

              <div id="appointment-tbl_wrapper" class="dataTables_wrapper no-footer">
                <!--Table Component-->
                <p-table
                  [rowHover]="true"
                  responsiveLayout="stack"
                  [lazy]="true"
                  (onLazyLoad)="
                    loadData($event, {
                      search: filter.searchTerm,
                      searchBy: [
                        'id',
                        'startDate',
                        'endDate'
                      ]
                    })
                  "
                  paginatorDropdownAppendTo="body"
                  [first]="first"
                  [rows]="rows"
                  [totalRecords]="totalRecords"
                  [value]="items"
                  [paginator]="true"
                  [rowsPerPageOptions]="[10, 20, 30]"
                  [globalFilterFields]="[
                    'id',
                    'startDate',
                    'endDate'
                  ]"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th pSortableColumn="id" style="width: 4%;" scope="col">
                        <span class="p-column-title"
                          ># <p-sortIcon field="id"
                        /></span>
                      </th>
                      <th  style="width: 9%;" scope="col">
                        {{ "appointment.protocolNo" | translate }}
                      </th>
                      <th pSortableColumn="username"  style="width: 7%;" scope="col">
                        {{ "appointment.username" | translate }}
                        <p-sortIcon field="username" />
                      </th>
                      <th pSortableColumn="surname"  style="width: 7%;" scope="col">
                        {{ "appointment.surname" | translate }}
                        <p-sortIcon field="surname" />
                      </th>
                      <th pSortableColumn="startDate" style="width: 12%;" scope="col">
                        <span class="p-column-title"
                          >{{ "appointment.start-date-label" | translate }}
                          <p-sortIcon field="startDate"
                        /></span>
                      </th>
                      <th pSortableColumn="appointmentStatus"  style="width: 12%;" scope="col">
                        {{ "appointment.appointmentStatus" | translate }}
                        <p-sortIcon field="appointmentStatus" />
                      </th>
                      <th pSortableColumn="caseStatus"  style="width: 10%;" scope="col">
                        {{ "appointment.caseStatus" | translate }}
                        <p-sortIcon field="caseStatus" />
                      </th>
                      <th pSortableColumn="caseType" style="width: 8%;" scope="col">
                        {{ "appointment.case-type" | translate }}
                        <p-sortIcon field="caseType" />
                      </th>
                      <th pSortableColumn="address" style="width: 10%;" scope="col">
                        {{ "appointment.address" | translate }}
                        <p-sortIcon field="address" />
                      </th>
                      <th pSortableColumn="patientNo" style="width: 8%;" scope="col">
                        {{ "appointment.patient-no" | translate }}
                        <p-sortIcon field="patientNo" />
                      </th>
                      <th pSortableColumn="patientNo" style="width: 16%;" scope="col">
                        {{ "appointment.planned-vehicle" | translate }}
                      </th>
                      <th style="width: 7%;" class="text-end" scope="col">
                      </th>

                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-appointment>
                    <tr>
                      <td>{{ appointment?.id }}</td>
                      <td>
                        {{appointment?.caseType?.valueObject?.code?.value }} - {{ appointment?.caseNo}}
                      </td>
                      <td>{{ appointment?.patientInformations?.firstName }}</td>
                      <td>{{ appointment?.patientInformations?.lastName }}</td>
                      <td>
                        {{ appointment?.appointmentStartDate | date: 'dd.MM.yyy HH:mm' : 'tr' }}
                      </td>
                      <td>{{ getAppointmentStatusText(appointment?.appointmentStatus) }}</td>
                      <td> {{ getCaseStatusText(appointment?.caseStatus)}}</td>
                      <td>{{ appointment?.caseType?.valueObject?.name?.value }}</td>
                      <td>{{ appointment?.addressInformations?.pickupAddress?.formattedAddress }}</td>
                      <td>{{ appointment?.patientInformations?.patient?.id }}</td>
                      <td>{{ appointment?.plannedVehicle?.licensePlate}}</td>
                      <td class="text-end appointment-actions-cell">
                        <div class="edit-history-actions">
                          <i
                            *ngIf="appointment?.recordType !== 'case'"
                            (click)="showAppointmentDetail(appointment?.id)"
                            class="pi pi-pencil edit-history-action-icon"
                            tabindex="-1"
                            [title]="'appointment.linkDetail' | translate"
                          ></i>

                          <i
                            (click)="showStatusDetail(appointment?.id)"
                            class="pi pi-history edit-history-action-icon"
                            tabindex="-1"
                            [title]="'appointment.showStatus' | translate"
                          ></i>

                          
                        <i *ngIf="appointment?.fieldSale?.id" class="fi fi-sr-user-headset edit-history-action-icon" coreTooltip="Görüşme Detayı"
                          (click)="showFieldSaleDetail(appointment?.fieldSale)"></i>
                        </div>
                      </td>

                    </tr>
                  </ng-template>

                  <ng-template pTemplate="paginatorleft">
                    {{ totalRecords }} Adet Bulundu
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="99">{{'appointment.empty-list-description' | translate}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





<div class="row" *ngIf="viewType=='card'" >

  <div class="col-xl-12 col-xxl-12">
      <div class="card">
          <div class="card-body">
              <div id="calendar" class="app-fullcalendar" (ngInit)="initCalendar()" >

              </div>
          </div>
      </div>
  </div>
  <!-- BEGIN MODAL -->
  <div class="modal fade none-border" id="event-modal">
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header">
                  <h4 class="modal-title"><strong>Add New Event</strong></h4>
              </div>
              <div class="modal-body"></div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-default waves-effect" data-bs-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-success save-event waves-effect waves-light">Create
                      event</button>

                  <button type="button" class="btn btn-danger delete-event waves-effect waves-light" data-bs-toggle="modal">Delete</button>
              </div>
          </div>
      </div>
  </div>
  <!-- Modal Add Category -->
  <div class="modal fade none-border" id="add-category">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h4 class="modal-title"><strong>Add a category</strong></h4>
<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                  <form>
                      <div class="row">
                          <div class="col-md-6">
                              <label class="control-label form-label" for="">Category Name</label>
                              <input class="form-control form-white" placeholder="Category Name" type="text" name="category-name">
                          </div>
                          <div class="col-md-6">
                              <label class="control-label form-label" for="">Choose Category Color</label>
                              <select class="form-control default-select form-white" data-placeholder="Choose a color..." name="category-color">
                                  <option value="success">Success</option>
                                  <option value="danger">Danger</option>
                                  <option value="info">Info</option>
                                  <option value="pink">Pink</option>
                                  <option value="primary">Primary</option>
                                  <option value="warning">Warning</option>
                              </select>
                          </div>
                      </div>
                  </form>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-danger light waves-effect" data-bs-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary waves-effect waves-light save-category" data-bs-toggle="modal">Save</button>
              </div>
          </div>
      </div>
  </div>
</div>


<app-toastr></app-toastr>
<app-sweet-alert></app-sweet-alert>
<app-loading [fullScreen]="true" [loading]="loading"></app-loading>

<app-loading [fullScreen]="true" [loading]="loadingStatus" [type]="'string'"   [message]="'appointment.waitingStatus' | translate"></app-loading>


<p-dialog [(visible)]="isVisible" modal [header]="'appointment.statuLogs' | translate" [style]="{ width: '60vw' }">
  <div class="status-history-container">
    <p-timeline [value]="processedLogs" align="alternate" styleClass="customized-timeline">
      <ng-template pTemplate="marker" let-statusLog>
        <span class="custom-marker" [ngClass]="'status-' + statusLog.id">
          <i class="pi pi-circle-fill"></i>
        </span>
      </ng-template>

      <ng-template pTemplate="content" let-statusLog>
        <div class="timeline-content">
          <div class="status-change">
            <!-- Eğer önceki durum varsa göster, yoksa sadece yeni durumu göster -->
            <ng-container *ngIf="statusLog.previousStatus; else noPrevoiusStatus">
              <span class="old-status">{{ statusLog.previousStatus }}</span>
              <i class="pi pi-arrow-right mx-2"></i>
              <span class="new-status" [ngClass]="'status-' + statusLog.newStatusId">
                {{ statusLog.currentStatus }}
              </span>
            </ng-container>

            <!-- Son kayıt için (önceki durum yok) - timeline'ın en altında -->
            <ng-template #noPrevoiusStatus>
              <i class="pi pi-arrow-right mx-2"></i>
              <span class="new-status" [ngClass]="'status-' + statusLog.newStatusId">
                {{ statusLog.currentStatus }}
              </span>
            </ng-template>
          </div>

          <div class="change-details">
            <div class="user-info">
              <i class="pi pi-user"></i>
              <span><b>{{'appointment.processUser' | translate}} </b>{{ statusLog.user?.firstName }} {{ statusLog.user?.lastName }}</span>
            </div>
            <div class="date-info">
              <i class="pi pi-calendar"></i>
              <span><b>{{'appointment.processDate' | translate}} </b> {{ statusLog.date | date: 'dd.MM.yyyy HH:mm' }}</span>
            </div>
          </div>
        </div>
      </ng-template>
    </p-timeline>

    <div class="no-history" *ngIf="!processedLogs || processedLogs.length === 0">
      <i class="pi pi-info-circle"></i>
      <span>{{'appointment.nonStatusHistory' | translate}}</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-secondary" (click)="closeStatusLogsDialog()">
      {{'appointment.close' | translate}}
    </button>
  </ng-template>
</p-dialog>
